import { z } from 'zod/v4';

// `email` is a legacy misnomer: the value is the stored `users.email_sha256`
// hash, not a plaintext email. Preserved as-is since existing unsubscribe
// links in already-sent emails encode this exact query param.
export const GetUserPreferencesByEmailShaQuerySchema = z.object({
  email: z.string().optional(),
});
export type GetUserPreferencesByEmailShaQuery = z.infer<
  typeof GetUserPreferencesByEmailShaQuerySchema
>;

export const UserPreferencesResultSchema = z.object({
  id: z.string(),
  preferences: z.record(z.string(), z.unknown()),
});
export type UserPreferencesResultView = z.infer<
  typeof UserPreferencesResultSchema
>;
